import { useEffect, useState, memo } from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@mui/material/TextField';
import {DebounceInput} from 'react-debounce-input';


const SangerPrimerRowName = memo((props) => {
    const data = props.data;
    const showAllErrors = props.showAllErrors;
    const submitShowError = props.submitShowError;
    const updatePrimerMap = props.updatePrimerMap;
    const primerKey = props.primerKey;
  
  return (
    <Grid item style={{}}>
        <DebounceInput
            debounceTimeout={500}
            minLength={1}
            element={TextField}
        required
        id="primer-name"
        placeholder={"Primer Name"}
        variant="outlined"
        sx={{'& .MuiInputBase-root': { height: 40, borderRadius: 0, width: 140 }, '& legend': { display: 'none' },
        '& fieldset': { top: 0 }, "& .MuiInputBase-input": {
        overflow: "hidden",
        textOverflow: "ellipsis"
        }}}
        disabled={data.labPrimer}
        InputLabelProps={{shrink: false, notched: false}}
        inputProps={{ spellCheck: false }}
        value={data.primerName}
        onChange={async (e) => {
        var newTouched = [...data.touched];
        newTouched[0] = true;
        updatePrimerMap(primerKey, { primerName: e.target.value, touched: newTouched});
        }}
        onBlur={(e) => {
        var newTouched = [...data.touched];
        newTouched[0] = true;
        updatePrimerMap(primerKey, { touched: newTouched});
        }}
        error={((data.touched[0] || submitShowError) && showAllErrors)}
    />
    </Grid>
    );
},
(prevProps, nextProps) => {
    return prevProps.id === nextProps.id && prevProps.data.primerName === nextProps.data.primerName;
});

export default SangerPrimerRowName;